import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import history from '../../services/history';

export default function LaudoCardHeader({ title }) {
  const handleBack = () => history.goBack();

  return (
    <Card.Header className="laudo-card-header d-flex justify-content-between align-items-center">
      <style>
        {`@media print {
          .laudo-card-header-back {
            display: none !important;
          }

          .laudo-card-header {
            justify-content: center !important;
          }

          .laudo-card-header h5 {
            width: 100%;
            text-align: center;
          }
        }`}
      </style>
      <Button
        size="sm"
        onClick={handleBack}
        aria-label="Voltar"
        className="laudo-card-header-back removeMePrint"
      >
        <FaArrowLeft />
      </Button>
      <h5 className="m-0 font-weight-bold">{title}</h5>
    </Card.Header>
  );
}
